import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { BusinessUnit } from '@delen/connect-core';
import { AppRoute, AppRouteParam } from '../app.route';
import { CONFIG } from '../core/config/config.token';

/**
 * Ensures only valid business units can be accessed.
 * @returns
 */
export const businessUnitGuard = (): CanActivateFn => {
  return (route: ActivatedRouteSnapshot) => {
    const config = inject(CONFIG);
    const router = inject(Router);

    const businessUnit = route.paramMap.get(AppRouteParam.BusinessUnit) as BusinessUnit;

    if (config.validBusinessUnits.includes(businessUnit)) {
      return true;
    }

    return router.createUrlTree(['/', AppRoute.PageNotFound]);
  };
};
